(() => {
  /*
   * Prevent duplicate document listeners if Shopify reloads
   * this section inside the theme editor.
   */
  if (window.__joansFabricPurchaseLoaded) {
    return;
  }

  window.__joansFabricPurchaseLoaded = true;

  function initialisePurchasePanels(root = document) {
    const panels = [];

    if (
      root instanceof Element &&
      root.matches("[data-joans-fabric-purchase]")
    ) {
      panels.push(root);
    }

    if (typeof root.querySelectorAll === "function") {
      panels.push(
        ...root.querySelectorAll("[data-joans-fabric-purchase]")
      );
    }

    panels.forEach((panel) => {
      initialisePurchasePanel(panel);
    });
  }

  function initialisePurchasePanel(panel) {
    if (panel.dataset.joansInitialised === "true") {
      return;
    }

    const productForm = panel.closest("form");

    if (!productForm) {
      console.error("Joan's: native product form not found");
      return;
    }

    panel.dataset.joansInitialised = "true";
    productForm.classList.add("joans-fabric-form--enhanced");

    /*
     * Mark the main fabric line so it can be identified
     * elsewhere in the cart logic.
     */
    let fabricMarkerInput = productForm.querySelector(
      'input[name="properties[_joans_fabric]"]'
    );

    if (!fabricMarkerInput) {
      fabricMarkerInput = document.createElement("input");
      fabricMarkerInput.type = "hidden";
      fabricMarkerInput.name = "properties[_joans_fabric]";
      fabricMarkerInput.value = "true";
      productForm.appendChild(fabricMarkerInput);
    }

    const nativeQuantity = productForm.querySelector(
      'input[name="quantity"]'
    );

    const nativeAddToCartButton = productForm.querySelector(
      'button[type="submit"][name="add"]'
    );

    const plusButton = panel.querySelector(
      "[data-joans-quantity-plus]"
    );

    const minusButton = panel.querySelector(
      "[data-joans-quantity-minus]"
    );

    const metresDisplay = panel.querySelector(
      "[data-joans-metres]"
    );

    const totalDisplay = panel.querySelector(
      "[data-joans-total]"
    );

    const customAddToCartButton = panel.querySelector(
      "[data-joans-add-to-cart]"
    );

    const threadAddButton = panel.querySelector(
      "[data-joans-thread-add]"
    );

    const threadControls = panel.querySelector(
      "[data-joans-thread-controls]"
    );

    const threadPlusButton = panel.querySelector(
      "[data-joans-thread-plus]"
    );

    const threadMinusButton = panel.querySelector(
      "[data-joans-thread-minus]"
    );

    const threadQuantityDisplay = panel.querySelector(
      "[data-joans-thread-quantity]"
    );

    const sampleButton = panel.querySelector(
      "[data-joans-add-sample]"
    );

    const unitPriceCents = Number.parseInt(
      panel.dataset.unitPrice || "",
      10
    );

    const threadPriceCents = Number.parseInt(
      panel.dataset.threadPrice || "",
      10
    );

    const threadVariantId = Number.parseInt(
      panel.dataset.threadVariantId || "",
      10
    );

    const sampleVariantId = Number.parseInt(
      panel.dataset.sampleVariantId || "",
      10
    );

    const fabricTitle = panel.dataset.fabricTitle || "";
    const fabricProductId = panel.dataset.fabricProductId || "";
    const fabricUrl = panel.dataset.fabricUrl || "";

    /*
     * Validate the existing fabric and thread controls first.
     * A sample configuration error must not disable metre ordering.
     */
    if (
      !nativeQuantity ||
      !nativeAddToCartButton ||
      !plusButton ||
      !minusButton ||
      !metresDisplay ||
      !totalDisplay ||
      !customAddToCartButton ||
      !threadAddButton ||
      !threadControls ||
      !threadPlusButton ||
      !threadMinusButton ||
      !threadQuantityDisplay ||
      Number.isNaN(unitPriceCents) ||
      Number.isNaN(threadPriceCents) ||
      Number.isNaN(threadVariantId)
    ) {
      console.error("Joan's: purchase panel data not found");
      return;
    }

    let threadQuantity = 0;
    let isAddingToCart = false;
    let isAddingSample = false;

    const originalAddToCartText =
      customAddToCartButton.textContent.trim();

    const originalSampleButtonText =
      sampleButton?.textContent.trim() || "";

    function notifyQuantityChange() {
      nativeQuantity.dispatchEvent(
        new Event("input", { bubbles: true })
      );

      nativeQuantity.dispatchEvent(
        new Event("change", { bubbles: true })
      );
    }

    function getFabricUnits() {
      return Number.parseInt(nativeQuantity.value, 10) || 1;
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat("en-NZ", {
        style: "currency",
        currency: "NZD",
      }).format(cents / 100);
    }

    function updateMetres() {
      const metres = getFabricUnits() / 10;

      metresDisplay.textContent = `${metres.toFixed(1)} m`;
    }

    function updateThreadDisplay() {
      if (threadQuantity > 0) {
        threadAddButton.hidden = true;
        threadControls.hidden = false;
        threadQuantityDisplay.textContent =
          String(threadQuantity);
      } else {
        threadAddButton.hidden = false;
        threadControls.hidden = true;
        threadQuantityDisplay.textContent = "1";
      }
    }

    function updateTotal() {
      const fabricTotalCents =
        getFabricUnits() * unitPriceCents;

      const threadTotalCents =
        threadQuantity * threadPriceCents;

      totalDisplay.textContent = formatMoney(
        fabricTotalCents + threadTotalCents
      );
    }

    function refreshDisplay() {
      updateMetres();
      updateThreadDisplay();
      updateTotal();
    }

    function changeFabricQuantity(direction) {
      if (direction === "increase") {
        nativeQuantity.stepUp();
      } else {
        nativeQuantity.stepDown();
      }

      notifyQuantityChange();
      refreshDisplay();
    }

    function changeThreadQuantity(direction) {
      if (direction === "increase") {
        threadQuantity += 1;
      } else {
        threadQuantity = Math.max(
          0,
          threadQuantity - 1
        );
      }

      refreshDisplay();
    }

    function setAddToCartLoading(isLoading) {
      isAddingToCart = isLoading;
      customAddToCartButton.disabled = isLoading;

      customAddToCartButton.textContent = isLoading
        ? "Adding…"
        : originalAddToCartText;
    }

    function setSampleLoading(isLoading) {
      if (!sampleButton) {
        return;
      }

      isAddingSample = isLoading;
      sampleButton.disabled = isLoading;

      sampleButton.textContent = isLoading
        ? "Adding…"
        : originalSampleButtonText;
    }

    async function addThreadToCart() {
      if (threadQuantity < 1) {
        return;
      }

      const cartRoot =
        window.Shopify?.routes?.root || "/";

      const response = await fetch(
        `${cartRoot}cart/add.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "same-origin",
          body: JSON.stringify({
  items: [
    {
      id: threadVariantId,
      quantity: threadQuantity,
      properties: {
        "Fabric": fabricTitle,
        "_Fabric product ID": fabricProductId,
        "_Fabric URL": fabricUrl,
      },
    },
  ],
}),
        }
      );

      const responseData = await response.json();

      if (!response.ok || responseData.status) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            "The matching thread could not be added."
        );
      }
    }

    async function addOrderToCart() {
      if (isAddingToCart) {
        return;
      }

      setAddToCartLoading(true);

      try {
        /*
         * Add the optional thread first.
         * Horizon then adds the fabric through its native form.
         * Its native refresh includes both cart items.
         */
        await addThreadToCart();

        nativeAddToCartButton.click();

        window.setTimeout(() => {
          setAddToCartLoading(false);
        }, 1800);
      } catch (error) {
        console.error(
          "Joan's: add to cart failed",
          error
        );

        setAddToCartLoading(false);

        window.alert(
          error instanceof Error
            ? error.message
            : "Something went wrong. Please try again."
        );
      }
    }

    async function addSampleToCart() {
      if (
        isAddingSample ||
        !sampleButton ||
        sampleButton.disabled
      ) {
        return;
      }

      if (
        Number.isNaN(sampleVariantId) ||
        !fabricTitle
      ) {
        console.error(
          "Joan's: sample product data not found"
        );

        window.alert(
          "The fabric sample could not be added. Please try again."
        );

        return;
      }

      const updateCart =
        window.Shopify?.actions?.updateCart;

      const openCart =
        window.Shopify?.actions?.openCart;

      if (
        typeof updateCart !== "function" ||
        typeof openCart !== "function"
      ) {
        console.error(
          "Joan's: Shopify cart actions are unavailable"
        );

        window.alert(
          "The fabric sample could not be added. Please refresh the page and try again."
        );

        return;
      }

      setSampleLoading(true);

      try {
        const result = await updateCart(
          {
            lines: [
              {
                merchandiseId:
                  String(sampleVariantId),

                quantity: 1,

                attributes: [
                  {
                    key: "Fabric",
                    value: fabricTitle,
                  },
                  {
                    key: "_Fabric product ID",
                    value: fabricProductId,
                  },
                  {
                    key: "_Fabric URL",
                    value: fabricUrl,
                  },
                ],
              },
            ],
          },
          {
            event: {
              context: "product",
              detail: {
                source: "joans-fabric-sample",
                productId: fabricProductId,
              },
            },
          }
        );

        if (result?.userErrors?.length) {
          throw new Error(
            result.userErrors[0].message ||
              "The fabric sample could not be added."
          );
        }

        if (result?.warnings?.length) {
          console.warn(
            "Joan's: sample cart warning",
            result.warnings
          );
        }

        sampleButton.textContent = "Added to cart";

        /*
         * Horizon decides how the cart is presented.
         * On this theme it opens and refreshes the cart drawer.
         */
        await openCart();

        window.setTimeout(() => {
          setSampleLoading(false);
        }, 1400);
      } catch (error) {
        console.error(
          "Joan's: sample add failed",
          error
        );

        setSampleLoading(false);

        window.alert(
          error instanceof Error
            ? error.message
            : "The fabric sample could not be added. Please try again."
        );
      }
    }

    /*
     * Default fabric cut:
     * 10 Shopify units = 1.0 metre.
     */
    nativeQuantity.value = 10;
    notifyQuantityChange();
    refreshDisplay();

    plusButton.addEventListener("click", () => {
      changeFabricQuantity("increase");
    });

    minusButton.addEventListener("click", () => {
      changeFabricQuantity("decrease");
    });

    threadAddButton.addEventListener("click", () => {
      threadQuantity = 1;
      refreshDisplay();
    });

    threadPlusButton.addEventListener("click", () => {
      changeThreadQuantity("increase");
    });

    threadMinusButton.addEventListener("click", () => {
      changeThreadQuantity("decrease");
    });

    customAddToCartButton.addEventListener(
      "click",
      () => {
        addOrderToCart();
      }
    );

    if (sampleButton) {
      if (
        Number.isNaN(sampleVariantId) ||
        !fabricTitle
      ) {
        sampleButton.disabled = true;

        console.error(
          "Joan's: Fabric Sample product is missing or unavailable"
        );
      } else {
        sampleButton.addEventListener(
          "click",
          () => {
            addSampleToCart();
          }
        );
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialisePurchasePanels()
    );
  } else {
    initialisePurchasePanels();
  }

  /*
   * Reinitialise if Shopify reloads the product section
   * inside the theme editor.
   */
  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initialisePurchasePanels(event.target);
    }
  );
})();